var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-popup",
    {
      staticStyle: { overflow: "hidden" },
      attrs: { id: _vm.nameId },
      on: { "popup:open": _vm.setServices },
    },
    [
      _c("page-nav-bar", {
        attrs: {
          subNavTitle: "MoneyRoad Services",
          closePopup: _vm.closeButton,
          isLeftPanel: true,
          notReturnButton: true,
          picker: false,
          switchService: true,
        },
      }),
      _vm._v(" "),
      _c(
        "f7-block",
        [
          _c(
            "row-grid-menu",
            {
              staticClass: "menuChangeService",
              attrs: { marginValue: _vm.marginvalue },
            },
            [
              "service-disabled" === "0"
                ? _c("menu-item", {
                    attrs: {
                      slot: "leftCol",
                      icon: "payments-grey",
                      label: "Request to Pay",
                      labelStyle: { size: "12", color: "grey" },
                      labelIcon: _vm.getServiceStatus(
                        _vm.services.payments.active
                      ),
                    },
                    slot: "leftCol",
                  })
                : _c(
                    "menu-item",
                    {
                      attrs: {
                        slot: "leftCol",
                        link: _vm.userIsGuest() ? "/inbox/0" : "/dashboard/",
                        icon: "payments",
                        service: true,
                        label: "Request to Pay",
                        labelStyle: { size: "12", color: "black" },
                        clickAction: {
                          name: "changeService",
                          value: _vm.services.payments,
                        },
                        closePopup: true,
                        labelIcon: _vm.getServiceStatus(
                          _vm.services.payments.active
                        ),
                      },
                      slot: "leftCol",
                    },
                    [
                      _c(
                        "f7-link",
                        {
                          staticClass: "serviceList",
                          attrs: { id: "enrollButton" },
                          on: {
                            click: function ($event) {
                              return _vm.enroll(_vm.services.payments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.getActiveStatus(
                                  _vm.services.payments.active
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              "service-disabled" === "0"
                ? _c("menu-item", {
                    attrs: {
                      slot: "rightCol",
                      icon: "exchangedoc-grey",
                      label: "Direct Payments",
                      labelStyle: { size: "12", color: "grey" },
                    },
                    slot: "rightCol",
                  })
                : _c(
                    "menu-item",
                    {
                      attrs: {
                        slot: "rightCol",
                        link: _vm.userIsGuest()
                          ? "/directPayments/inbox/"
                          : "directPayments/dashboard/",
                        icon: "exchangedoc",
                        service: true,
                        label: "Direct Payments",
                        labelStyle: { size: "12", color: "black" },
                        clickAction: {
                          name: "changeService",
                          value: _vm.services.directPayments,
                        },
                        closePopup: true,
                      },
                      slot: "rightCol",
                    },
                    [
                      _c(
                        "f7-link",
                        {
                          staticClass: "serviceList",
                          attrs: { id: "enrollButton" },
                          on: {
                            click: function ($event) {
                              return _vm.enroll(_vm.services.directPayments)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.getActiveStatus(
                                  _vm.services.directPayments.active
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "row-grid-menu",
            { attrs: { marginValue: _vm.marginvalue } },
            [
              "service-disabled" === "0"
                ? _c("menu-item", {
                    attrs: {
                      slot: "leftCol",
                      icon: "sepa-grey",
                      label: "Modular Loan",
                      labelStyle: { size: "12", color: "grey" },
                      labelIcon: _vm.getServiceStatus(
                        _vm.services.directDebit.active
                      ),
                    },
                    slot: "leftCol",
                  })
                : _c(
                    "menu-item",
                    {
                      attrs: {
                        slot: "leftCol",
                        link: _vm.userIsGuest()
                          ? "/directDebit/inbox/"
                          : "/directDebit/dashboard/",
                        service: true,
                        icon: "sepa",
                        label: "Modular Loan",
                        labelStyle: { size: "12", color: "black" },
                        clickAction: {
                          name: "changeService",
                          value: _vm.services.directDebit,
                        },
                        closePopup: true,
                        labelIcon: _vm.getServiceStatus(
                          _vm.services.directDebit.active
                        ),
                      },
                      slot: "leftCol",
                    },
                    [
                      _c(
                        "f7-link",
                        {
                          staticClass: "serviceList",
                          attrs: { id: "enrollButton" },
                          on: {
                            click: function ($event) {
                              return _vm.enroll(_vm.services.directDebit)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.getActiveStatus(
                                  _vm.services.directDebit.active
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("menu-item", {
                attrs: {
                  slot: "rightCol",
                  icon: "invoicedirect-grey",
                  label: _vm.DirectInvoiceLabel,
                  labelStyle: { size: "12", color: "grey" },
                  clickAction: { name: "doNothing", value: "" },
                },
                slot: "rightCol",
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }